import { environment } from "../environments/environment";
export class BaseService {
    dynamoBaseApiUrl: string;
     constructor(
       
    ) {
        
        this.dynamoBaseApiUrl = environment.DynamoDBAPI;
    }
}